import React from 'react';
import keyDetail from '../img/Detail/Key-Detail.jpg';
import './Detail.css';
const KeyDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={keyDetail} alt="Artist Artwork" />
    </div>
  );
};

export default KeyDetail;
